import NiceModal from "@ebay/nice-modal-react";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { logoutUser } from "../../../redux/reducers/userReducer";
import CustomHref from "../../core/blocks/CustomHref";
import { Button } from "../../core/basic/Button";
import { ChangeOrgModal } from "../../../modules/admin/ChangeOrgModal";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { css, cx } from "../../../../styled-system/css";

const OnboardingFooter = () => {
  const { t } = useTranslation(["common"]);
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <div
      className={cx(
        css({ position: "absolute", bottom: "25px", right: "50px", zIndex: "stickyBar", gap: "large" }),
        "d-flex justify-content-end align-items-center",
      )}
    >
      {user.is_staff && (
        <Button variant="link" fontSize={"large"} fontWeight={"bold"} onPress={() => NiceModal.show(ChangeOrgModal)}>
          {t(($) => $.common.sidebar["Switch Profiles"])}
        </Button>
      )}
      <CustomHref
        text={
          <span
            className="fs-3"
            onClick={(e) => {
              e.preventDefault();
              dispatch(logoutUser());
              navigate({ to: "/" });
            }}
          >
            {t(($) => $.common.Logout)}
          </span>
        }
      />
    </div>
  );
};

export default OnboardingFooter;
